export const workorderChecklistQuickListOptions = [
  {
    value:
      'domain.enums.checklist_quick_enum.wheel_wrench_jack_and_safety_triangle',
    label: 'Chave de roda, macaco e triângulo de segurança',
  },
  {
    value:
      'domain.enums.checklist_quick_enum.dashboard_instruments_and_control_lamps',
    label: 'Instrumentos do painel e lâmpadas de controle',
  },
  {
    value:
      'domain.enums.checklist_quick_enum.brake_fluid_level_quality_color_contamination',
    label: 'Fluido de freio: nível, qualidade (cor, contaminação)',
  },
  {
    value: 'domain.enums.checklist_quick_enum.internal_lamps',
    label: 'Lâmpadas internas',
  },
  {
    value:
      'domain.enums.checklist_quick_enum.air_conditioning_hot_air_ventilation',
    label: 'Ar-condicionado / Ar-Quente / Ventilação',
  },
  {
    value: 'domain.enums.checklist_quick_enum.dashboard_instrument_lighting',
    label: 'Iluminação dos instrumentos do painel',
  },
  {
    value: 'domain.enums.checklist_quick_enum.general_leaks',
    label: 'Vazamentos gerais',
  },
  {
    value: 'domain.enums.checklist_quick_enum.cold_start_reservoir',
    label: 'Reservatório de partida frio',
  },
  {
    value: 'domain.enums.checklist_quick_enum.wiper_system_top_up_reservoir',
    label: 'Sistema de limpa-vidros / completar reservatório',
  },
  {
    value:
      'domain.enums.checklist_quick_enum.lighting_system_ex_headlights_turn_signals_brake_license_plate_reverse',
    label: 'Sistema de iluminação (Ex: farois, setas, freio, placa, ré)',
  },
  {
    value: 'domain.enums.checklist_quick_enum.coolant_leakage_level_additive',
    label: 'Líquido de arrefecimento (vazamento, nível, aditivo)',
  },
  {
    value:
      'domain.enums.checklist_quick_enum.check_windshield_wipers_water_jet',
    label: 'Verificar jato dágua dos limpadores de parabrisa',
  },
  {
    value: 'domain.enums.checklist_quick_enum.engine_oil_level',
    label: 'Nível do óleo do Motor',
  },
  {
    value: 'domain.enums.checklist_quick_enum.fire_extinguisher',
    label: 'Extintor de incêndio',
  },
  {
    value:
      'domain.enums.checklist_quick_enum.direction_arrows_and_signal_lights',
    label: 'Setas de direção e luzes de sinalização',
  },
  {
    value: 'domain.enums.checklist_quick_enum.hydraulic_oil_level_steering_oil',
    label: 'Nível do óleo hidráulico (óleo de direção)',
  },
  {
    value:
      'domain.enums.checklist_quick_enum.check_tire_conditions_pressure_including_spare_tire',
    label: 'Verificar condições dos pneus / pressão (inclusive estepe)',
  },
  {
    value: 'domain.enums.checklist_quick_enum.oil_label',
    label: 'Etiqueta de Óleo',
  },
  {
    value: 'domain.enums.checklist_quick_enum.electric_window',
    label: 'Vidro elétrico',
  },
  { value: 'domain.enums.checklist_quick_enum.horn', label: 'Buzina' },
  {
    value: 'domain.enums.checklist_quick_enum.parking_brake',
    label: 'Freio Estacionamento',
  },
  {
    value:
      'domain.enums.checklist_quick_enum.windshield_and_rear_window_wiper_blades',
    label: 'Palhetas dos limpadores de parabrisa e vidro traseiro',
  },
];
